import { MediaSourceType } from '../../types';
export function getTransKeyForMediaSourceType(mediaSource) {
    var _a;
    var mediaSourceTypeToLabelMap = (_a = {},
        _a[MediaSourceType.GALLERY] = 'mediapopup.myGalleries',
        _a[MediaSourceType.COLLECTION] = 'mediapopup.myCollections',
        _a[MediaSourceType.STASH] = 'mediapopup.myStash',
        _a[MediaSourceType.BROWSE] = 'mediapopup.browse',
        _a);
    return mediaSourceTypeToLabelMap[mediaSource];
}
export function getAllMediaSourceTypes() {
    return [
        MediaSourceType.GALLERY,
        MediaSourceType.COLLECTION,
        MediaSourceType.STASH,
        MediaSourceType.BROWSE,
    ];
}
//# sourceMappingURL=_helpers.js.map